export default __webpack_public_path__ + "static/media/img-3462.048eab57.jpeg";